'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SvgIcon2 = require('./SvgIcon');

var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Tasks = (_temp = _class = function (_SvgIcon) {
  _inherits(Tasks, _SvgIcon);

  function Tasks() {
    _classCallCheck(this, Tasks);

    return _possibleConstructorReturn(this, (Tasks.__proto__ || Object.getPrototypeOf(Tasks)).apply(this, arguments));
  }

  _createClass(Tasks, [{
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(
          _SvgIcon3['default'],
          this.props,
          _react2['default'].createElement('path', { d: 'M31.99957,10.00043a2.00394,2.00394,0,0,0-2-2A2.00424,2.00424,0,0,0,27.99506,6H8.00494A2.00455,2.00455,0,0,0,6,8.00494V27.99506a2.00425,2.00425,0,0,0,2.00043,2.00452,2.00394,2.00394,0,0,0,2,2A2.00424,2.00424,0,0,0,12.00494,34H31.99506A2.00455,2.00455,0,0,0,34,31.99506V12.00494A2.00425,2.00425,0,0,0,31.99957,10.00043ZM8,10.00494V28.999a1.00557,1.00557,0,0,1-1-1.004V8.00494A1.00607,1.00607,0,0,1,8.00494,7H27.99506a1.00557,1.00557,0,0,1,1.004,1H10.00494A2.00455,2.00455,0,0,0,8,10.00494Zm2,2V30.999A1.00509,1.00509,0,0,1,9.001,30L9,29.99506V10.00494A1.00607,1.00607,0,0,1,10.00494,9H29.99506L30,9.001a1.00509,1.00509,0,0,1,.999.999H12.00494A2.00455,2.00455,0,0,0,10,12.00494ZM26.5,13.5a1.25244,1.25244,0,0,1-1.2514,1.25H18.7514a1.25,1.25,0,1,1,0-2.5H25.2486A1.24764,1.24764,0,0,1,26.5,13.5ZM31.99506,32,12,31.99506,12.00372,17H31.99878l-.00323,13.03931c.00031-.01508.00446-.02911.00446-.04425C32,30.01019,31.99506,32,31.99506,32Z' }),
          _react2['default'].createElement('path', { d: 'M20.333,30a1.50334,1.50334,0,0,1-1.00342-.38477l-3.333-3a1.5002,1.5002,0,0,1,2.00684-2.23047l2.17529,1.958,5.66895-6.80322A1.5,1.5,0,0,1,28.15234,21.46l-6.667,8a1.49994,1.49994,0,0,1-1.04492.53613C20.4043,29.999,20.36816,30,20.333,30Z' })
        );
      }

      return render;
    }()
  }]);

  return Tasks;
}(_SvgIcon3['default']), _class.defaultProps = {
  viewBox: '0 0 40 40'
}, _temp);
exports['default'] = Tasks;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui/SvgIcon/Tasks.js
// module id = 765
// module chunks = 32